import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import MetaTag from 'components/meta';
import styles from 'components/nonPodiatry/page.module.scss';
import useIncompleteTempoRedirect from 'hooks/useIncompleteTempoRedirect';

function CompletedReasonForVisit() {
  useIncompleteTempoRedirect(true);

  return (
    <>
      <MetaTag title="The submission has been successful." />
      <Box pb={1}>
        <Box
          minHeight="70vh"
          mt={2}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography fontSize="40px">Congratulations!</Typography>
          <p className={styles.titleTextSubText}>
            The submission has been successful.
          </p>
        </Box>
      </Box>
    </>
  );
}

export default CompletedReasonForVisit;
